import { createAction, handleActions } from 'redux-actions';

const ACTIVE_SELECTBOX_MODAL= 'selectBox/ACTIVE_SELECTBOX_MODAL';

export const isACtiveSelectBoxModal = createAction(ACTIVE_SELECTBOX_MODAL);

const initialState = {
  selectboxModal:{
    selectStatus:false,
    selectTitle:'',
    contentOne:[],
    trashBagStatus:false,
  },
};

const selectBox = handleActions(
  {
    [ACTIVE_SELECTBOX_MODAL]:   (state, { payload: selectboxModal }) => selectboxModal,
  },
  initialState
);

export default selectBox;
